// Import external
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({

    selector: 'syn-language-input',
    templateUrl: 'language-input.component.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => LanguageInputComponent), multi: true }
    ]
})
export class LanguageInputComponent implements ControlValueAccessor {

    @Input() placeholder = 'Langue';

    // I18N: need to translate later on
    public readonly AVAILABLE_LANGUAGES = [{
        code: 'fr',
        name: 'Français'
    }, {
        code: 'en',
        name: 'Anglais'
    }
    ];

    private _language;

    @Input('language')
    get language() {
        return this._language;
    }

    set language(val) {
        this._language = val;
        this.onChange(val);
        this.onTouched();
    }

    // these functions will be registered later
    onChange: any = () => { };
    onTouched: any = () => { };
    validateFn: any = () => { };

    writeValue(value) {
        if (value) {
            this.language = value;
        }
    }

    registerOnChange(fn) {
        this.onChange = fn;
    }

    registerOnTouched(fn) {
        this.onTouched = fn;
    }

    validate(c: FormControl) {
        return this.validateFn(c);
    }
}
